<template>
  <div class="vs-page" style="background: var(--vs-canvas); min-height: 100vh; padding: 20px 0;">
    <div class="vs-wrap" style="max-width: 1600px; margin: 0 auto; width: 96%;">

      <header class="vs-hero" style="margin-bottom: 20px;">
        <div class="vs-hero-grid" style="grid-template-columns: 1fr;">
          <div class="vs-hero-invoice">
            <div class="vs-hero-label">Inventory</div>
            <div class="vs-hero-number">TRANSFERS</div>
            <div class="vs-hero-tags">
              <span class="vs-tag is-teal"><b-icon icon="shop"></b-icon> Store Orders</span>
              <span class="vs-tag is-orange"><b-icon icon="building"></b-icon> Warehouse Transfers</span>
            </div>
          </div>
        </div>
      </header>

      <b-tabs card v-model="activeTab" class="custom-tabs" @input="onTabChange">
        <b-tab title="STORE ORDERS" style="padding: 10px;">
          <div class="vs-card" style="margin-bottom: 14px;">
            <div class="vs-card-head" style="margin-bottom: 0;">
              <div class="vs-card-title">
                <span class="vs-icon"><b-icon icon="shop"></b-icon></span>
                <div>
                  <h3>Store Transfer Orders</h3>
                  <p>Orders placed by stores to replenish from warehouses or other stores.</p>
                </div>
              </div>
              <b-button class="vs-btn-primary" @click="openNewOrderModal">
                <b-icon icon="plus-circle"></b-icon> Create Store Order
              </b-button>
            </div>
          </div>

          <ListStoreOrders ref="listStoreOrders" @view-order="openViewOrder" />
        </b-tab>

        <b-tab title="WAREHOUSE TRANSFERS" style="padding: 10px;">
          <div class="vs-card" style="margin-bottom: 14px;">
            <div class="vs-card-head" style="margin-bottom: 0;">
              <div class="vs-card-title">
                <span class="vs-icon" style="background: var(--vs-orange);"><b-icon icon="building"></b-icon></span>
                <div>
                  <h3>Warehouse Transfers</h3>
                  <p>Internal stock movement between warehouses only.</p>
                </div>
              </div>
            </div>
          </div>

          <ListTransferOrders />
        </b-tab>
      </b-tabs>
    </div>

    <!-- NEW ORDER MODAL -->
    <b-modal
      id="modal-new-store-order"
      size="xl" centered scrollable hide-footer
      title="Create Store Order"
      content-class="pos-modal" dialog-class="pos-dialog"
    >
      <NewStoreOrderForm
        v-if="newOrderModalOpen"
        :key="'new-order-' + newOrderKey"
        @order-completed="handleOrderCompleted"
      />
    </b-modal>

    <!-- VIEW ORDER MODAL -->
    <StoreOrderDetailsModal
      v-if="viewOrderId"
      :order-id="viewOrderId"
      @closed="handleViewOrderClosed"
    />
  </div>
</template>

<script>
import ListTransferOrders from '@/components/TransferOrders/ListTransferOrders'
import ListStoreOrders from '@/components/TransferOrders/ListStoreOrders'
import NewStoreOrderForm from '@/components/TransferOrders/NewStoreOrderForm'
import StoreOrderDetailsModal from '@/components/TransferOrders/StoreOrderDetailsModal'

export default {
  name: "TransferOrdersMain",
  components: { ListTransferOrders, ListStoreOrders, NewStoreOrderForm, StoreOrderDetailsModal },
  data() {
    return {
      activeTab: 0,
      packet: {},
      newOrderModalOpen: false,
      newOrderKey: 0,
      viewOrderId: null,
    }
  },
  methods: {
    onTabChange(tabIndex) {
      if (tabIndex === 0 && this.$refs.listStoreOrders) {
        this.$refs.listStoreOrders.fetchOrders();
      }
    },
    openNewOrderModal() {
      this.newOrderKey++;
      this.newOrderModalOpen = true;
      this.$nextTick(() => this.$bvModal.show('modal-new-store-order'));
    },
    handleOrderCompleted() {
      this.$bvModal.hide('modal-new-store-order');
      this.newOrderModalOpen = false;
      if (this.$refs.listStoreOrders) this.$refs.listStoreOrders.fetchOrders();
    },
    openViewOrder(order) {
      this.viewOrderId = order.id;
    },
    handleViewOrderClosed() {
      this.viewOrderId = null;
      if (this.$refs.listStoreOrders) this.$refs.listStoreOrders.fetchOrders();
    },
  },
  created() {
    this.packet = JSON.parse(localStorage.packet || '{}');
    this.packet.userDetails = JSON.parse(localStorage.userDetails || '{}');
  }
}
</script>

<style scoped>
.custom-tabs >>> .nav-tabs {
  border-bottom: 3px solid #E5E1DA;
}
.custom-tabs >>> .nav-tabs .nav-link {
  font-weight: 700; font-size: 15px; color: #736C63;
  border: 1px solid transparent; border-radius: 12px 12px 0 0;
  padding: 12px 24px; background: #F7F5F2;
}
.custom-tabs >>> .nav-tabs .nav-link.active {
  background: #221F1C; color: #fff; border-color: #221F1C;
}
.custom-tabs >>> .tab-content {
  border: 1.5px solid #E5E1DA; border-top: none;
  border-radius: 0 0 12px 12px; background: #fff;
}
.vs-card { background: #fff; border: 1px solid #E5E1DA; border-radius: 18px; padding: 20px 22px; }
.vs-card-head { display: flex; justify-content: space-between; align-items: center; gap: 14px; flex-wrap: wrap; margin-bottom: 16px; }
.vs-card-title { display: flex; gap: 12px; align-items: center; min-width: 0; }
.vs-card-title h3 { font-family: 'Sora', 'Manrope', sans-serif; font-size: 18px; font-weight: 700; margin: 0; color: #221F1C; }
.vs-card-title p { margin: 2px 0 0; font-size: 13px; color: #736C63; }
.vs-icon {
  width: 42px; height: 42px; border-radius: 12px; flex-shrink: 0;
  background: #EE7A22; color: #fff;
  display: inline-flex; align-items: center; justify-content: center; font-size: 18px;
}
.vs-btn-primary.btn, .vs-btn-ghost.btn {
  border-radius: 10px !important; font-weight: 700; font-size: 14px;
  padding: 8px 16px; display: inline-flex; align-items: center; gap: 7px; box-shadow: none !important;
}
.vs-btn-primary.btn { background: #EE7A22 !important; border: 1.5px solid #EE7A22 !important; color: #fff !important; }
.vs-btn-primary.btn:hover:not(:disabled) { background: #D4620F !important; border-color: #D4620F !important; }
.vs-hero { background: #221F1C; color: #fff; border-radius: 20px; overflow: hidden; border-bottom: 5px solid #EE7A22; }
.vs-hero-grid { display: grid; padding: 22px 30px; }
.vs-hero-label { font-size: 13px; color: rgba(255,255,255,0.6); font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; }
.vs-hero-number { font-family: 'Sora', sans-serif; font-size: 32px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.1; }
.vs-hero-tags { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
.vs-tag { font-size: 13px; font-weight: 700; padding: 4px 12px; border-radius: 999px; }
.vs-tag.is-teal   { background: #0F6E6B; color: #fff; }
.vs-tag.is-orange { background: #FFF1E4; color: #D4620F; }
</style>


// WEBPACK FOOTER //
// src/components/TransferOrders/TransferOrdersMain.vue